var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-progress',{class:{'complete':_vm.status === 'success'},attrs:{"text-inside":false,"percentage":_vm.currentPercentage,"show-text":_vm.showText,"color":"#67c23a"}})}
var staticRenderFns = []

export { render, staticRenderFns }